import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { autogenerateFullName: { type: Boolean, default: false },
    autogenerateShortName: { type: Boolean, default: false } }

  static targets = ['fullName', 'shortName', 'autogenerateFullNameHint', 'autogenerateShortNameHint',
    'startTimeContainer', 'endTimeContainer']

  toggleAr(event) {
    if(event.target.checked) {
      this.startTimeContainerTarget.classList.add('d-none')
      this.endTimeContainerTarget.classList.add('d-none')
    } else {
      this.startTimeContainerTarget.classList.remove('d-none')
      this.endTimeContainerTarget.classList.remove('d-none')
    }
  }

  toggleAutoGenerateFullName(event) {
    if(event.target.checked) {
      this.autogenerateFullNameValue = true
    } else {
      this.autogenerateFullNameValue = false
    }
  }

  toggleAutoGenerateShortName(event) {
    if(event.target.checked) {
      this.autogenerateShortNameValue = true
    } else {
      this.autogenerateShortNameValue = false
    }
  }

  autogenerateFullNameValueChanged() {
    if(this.autogenerateFullNameValue) {
      this.fullNameTarget.disabled = true
      this.autogenerateFullNameHintTarget.classList.remove('d-none')
    } else {
      this.fullNameTarget.disabled = false
      this.autogenerateFullNameHintTarget.classList.add('d-none')
    }
  }

  autogenerateShortNameValueChanged() {
    if(this.autogenerateShortNameValue) {
      this.shortNameTarget.disabled = true
      this.autogenerateShortNameHintTarget.classList.remove('d-none')
    } else {
      this.shortNameTarget.disabled = false
      this.autogenerateShortNameHintTarget.classList.add('d-none')
    }
  }
}
